import products from 'app/config/files/products.json';
import { Products } from 'app/models/types/common/ProductsConfig';

export const getCountryPassengerRulesExtended = () =>
  (products.country_passenger_rules_extended as Products['country_passenger_rules_extended']);
